// 파트너사 로고는 src/assets/images/partners/<번호>_<이름>.{png,jpg} 형식으로 보관.
// Vite glob import 로 일괄 번들링 → 파일을 추가/제거하면 자동 반영됩니다.
const logoModules = import.meta.glob('../assets/images/partners/*.{png,jpg,jpeg}', {
  eager: true,
  import: 'default',
  query: '?url',
});

// 번호 → 공식 사이트 URL.
// 2026-05-08 기준 67개 중 4개는 root 도메인으로 교체(deep path 4xx/5xx),
// 5개는 도메인이 만료되었거나 서버 응답 없음 → null 로 두어 링크 비활성화.
// 2026-05-27: 메디쿱스(no.37) 제거 — 이미지 파일도 함께 삭제됨.
const urlByNo = {
  1: 'https://www.gccare.net/', // 구 GC헬스케어 → GC케어로 도메인 이전
  2: 'https://www.greencrosswb.com/',
  3: 'https://m.daewoong.co.kr/kr/main/index',
  4: 'http://curadenkorea.com/',
  5: 'https://www.dong-wha.co.kr/dw_main.asp',
  6: 'https://imegagen.com/ko/patients/megagen_implants/',
  7: 'https://www.no1health2.or.kr:19621/_new/', // 안국약품 No1Health 브랜드 페이지
  8: 'https://glpt.co.kr/',
  9: 'http://www.cellumed.co.kr/', // 기존 deep path 500 → root
  10: 'https://mgensolutions.kr/index.php', // 구 엠젠플러스 → 엠젠솔루션즈로 사명 변경
  11: 'http://idreamtech.co.kr/kr/',
  12: 'https://www.raymedical.com/ko', // 신규 글로벌 도메인 (.com/ko)
  13: 'http://www.raydent.co.kr/main/main.html', // 케어덴트 → 레이덴트로 상호 변경
  14: 'https://atsens.com/atsens/index.html',
  15: 'http://www.c-bh.co.kr/', // 기존 deep path 404 → root
  16: 'https://helixmith.com/',
  17: 'https://www.daain.com/?lang=ko',
  18: 'https://www.thecellmeat.com/',
  19: 'http://www.syntekabio.com/',
  20: 'https://www.aiobio.co.kr/',
  21: 'http://www.autotacbio.com/',
  22: 'http://www.zti-bio.com/',
  23: 'http://www.qubest.co.kr/index.php',
  24: 'http://koreatoothbank.com/',
  25: null, // nexyonbio.com — DNS 응답하나 reachable 아님
  26: 'https://milkinlab.com/index.html',
  27: 'http://zymedi.com/',
  28: 'http://nanomedica.co.kr/index.php',
  29: 'http://www.biocozglobal.com/',
  30: 'https://3billion.io/ko/',
  31: 'https://www.ondemand3d.com/',
  32: 'https://imagoworks.ai/',
  33: 'https://www.papricacare.com/',
  34: 'https://www.mongata.co/',
  35: 'http://mirnetwork.co.kr/',
  36: 'https://www.gcimed.com/main',
  38: 'https://isongdo.com/',
  39: 'https://www.jenith.co.kr/main_video2.html',
  40: 'http://www.lamiche.co.kr/',
  41: 'https://www.wellmc.com/',
  42: 'https://www.thewisedental.com/index.html',
  43: 'http://www.bestyoyang.com/',
  44: 'http://www.gn365songdo.com/',
  45: 'http://www.onedaydent.com/about/introduce.html',
  46: 'https://2d2d.co.kr/',
  47: 'https://sisunps.com/',
  48: 'https://www.moaman.kr/main/',
  49: 'https://www.ccye.kr/',
  50: 'http://www.underrodem.com/',
  51: 'http://www.mansei.kr/',
  52: 'http://thebarohospital.com/',
  53: 'https://dental.odoctor.co.kr/',
  54: 'https://smartdoctor.cc/',
  55: 'https://www.himedi.com/en',
  56: 'http://www.theway-hc.co.kr/', // 기존 deep path 404 → root
  57: 'http://www.neumed.co.kr/index.php',
  58: 'https://www.cenyxbiotech.com/',
  59: 'http://www.youthfill.co.kr/',
  60: 'https://www.khidi.or.kr/kps',
  61: 'https://www.kda.or.kr/kda/index.kda',
  62: 'https://www.sda.or.kr/',
  63: 'https://www.kao.or.kr/general/main/main.html',
  64: 'http://www.kaoms.org/',
  65: 'https://www.koa.or.kr/', // 대한정형외과학회 공식 (KOA — 기존 POSA 표기 오류)
  66: 'https://www.kdtech.or.kr/', // 대한치과기공사협회 공식 (KDTECH — 기존 KAVA 표기 오류)
  67: 'https://www.seoulbiohub.kr/front/user/main.do',
};

// 파일명만으로 추출되는 이름이 실제 상호와 다른 경우 override.
// (사이트 점검으로 확인된 정식 상호명, 2026-05-08)
const displayNameByNo = {
  1: 'GC케어',
  7: '안국약품',
  8: '지엘팜텍',
  10: '엠젠솔루션',
  31: '사이버메드',
  36: 'GC녹십자아이메드',
  38: '서울송도병원',
  40: '라미체의원',
  41: '대전웰니스병원',
  42: '더와이즈치과병원',
  43: '연세베스트요양병원',
  44: '강남365치과 송도점',
  45: '원데이치과',
  46: '2D치과의원',
  47: '시선성형외과',
  49: '춘천예치과',
  50: '언더로뎀요양병원',
  51: '만세정형외과',
  52: '연세더바로의원',
  56: '더웨이헬스케어',
  65: '대한정형외과학회',
  66: '대한치과기공사협회',
};

function parseEntry(path, url) {
  const filename = path.split('/').pop();
  const base = filename.replace(/\.(png|jpg|jpeg)$/i, '');
  const [noStr, ...rest] = base.split('_');
  const no = Number(noStr);

  let name;
  if (rest.length <= 1) {
    name = rest.join(' ');
  } else {
    const last = rest[rest.length - 1];
    if (/^[A-Za-z0-9]+$/.test(last)) {
      name = `${rest.slice(0, -1).join(' ')} (${last})`;
    } else {
      name = rest.join(' ');
    }
  }

  return {
    no,
    name: displayNameByNo[no] ?? name,
    logo: url,
    url: urlByNo[no] ?? null,
  };
}

export const partners = Object.entries(logoModules)
  .map(([path, url]) => parseEntry(path, url))
  .sort((a, b) => a.no - b.no);
